function handleMobileFilters() {
  document.querySelectorAll('.mobile-filters-close').forEach(btn => {
    btn.addEventListener('click', () => {
      document.querySelector('#filters-mobile-btn').click();
    })
  })
}

function handleSortByMobile(){
  const divsToWatch = document.querySelectorAll('.collection__single-sorting-text');
  divsToWatch.forEach(function(div){
    div.addEventListener('click', function(){
      let sortValue = div.getAttribute('data-value');
      updateSortByParameter(sortValue);
      window.location.reload();
    })
  })
}

function updateSortByParameter(sortValue){
  let searchParams = new URLSearchParams(window.location.search)
  searchParams.set('sort_by', sortValue);
  window.history.replaceState({}, document.title, `${window.location.pathname}?${searchParams.toString()}`);
}

function fillPriceInputs() {
  let searchParams = new URLSearchParams(window.location.search);
  document.querySelectorAll('.collection__price-input').forEach(input => {
    input.value = searchParams.get(input.name);
  })
}

function handleInputs() {
  document.querySelectorAll(".price-form-js").forEach(form => {
    form.addEventListener("submit", function(event){
      event.preventDefault();
      sendData();
    })
    form.addEventListener("keypress", function(event){
      if(event.key === 'Enter'){
        event.preventDefault();
        sendData()
      }
    })
    if (form.classList.contains('desktop-form')) {
      form.querySelectorAll('input[type=number]').forEach(input => {
        input.addEventListener('change', () => sendData())
      })
    }
  
    function sendData(){
      form.submit();
    }
  })
}

function handleRemovingFilters() {
  document.querySelectorAll('.delete-filter-js').forEach(button => {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      let path = window.location.pathname.slice(0, window.location.pathname.lastIndexOf('/'))
      let subpath = window.location.pathname.split('/').slice(-1)[0];
      let searchParams = new URLSearchParams(window.location.search)
      let filter = button.dataset.filter;
      if (filter == "price_range") {
        searchParams.delete('filter.v.price.gte');
        searchParams.delete('filter.v.price.lte');
      } else if (filter == 'sort-by') {
        searchParams.delete('sort_by');
      } else {
        let tmp = subpath.split('+');
        tmp.splice(tmp.indexOf(filter), 1);
        subpath = tmp.join('+');
      }
      window.location.href = `${path}/${subpath}?${searchParams.toString()}`;
    })
  })
}

function handleAddToBasketModals() {
  document.querySelectorAll('.collection__product-buy-btn').forEach(button => {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      let url = button.href;
      document.body.style.overflow = 'hidden';
      document.querySelector("#shopify-section-header").classList.add('blur');
      document.querySelector("main").classList.add('blur');
      document.getElementById("product-modal").classList.add('visible');
      document.getElementById("product-modal").parentNode.style.display = 'block';
      document.getElementById("product-modal").parentNode.classList.add('visible');

      const xhttp = new XMLHttpRequest();
      xhttp.onload = function() {
        const text = this.responseText;
        const parser = new DOMParser();
        let text_ = parser.parseFromString(text, 'text/html');
        text_ = text_.getElementById('modal-content-js');
        document.getElementById("product-modal").innerHTML = text_.innerHTML;

        document.querySelector("#product-modal .modal-close-js").setAttribute('aria-hidden', 'false');
        document.querySelector("#product-modal .modal-close-js").addEventListener('click', () => {
          document.body.style.overflow = 'visible';
          document.querySelector("#shopify-section-header").classList.remove('blur');
          document.querySelector("main").classList.remove('blur');
          document.getElementById("product-modal").classList.remove('visible');
          document.getElementById("product-modal").parentNode.style.display = 'none';
          document.getElementById("product-modal").parentNode.classList.remove('visible');
          document.getElementById("product-modal").innerHTML = null;
        })
      }
      xhttp.open("GET", url, true);
      xhttp.send();
    })
  })
}


function collectionScripts() {
  handleMobileFilters();
  handleSortByMobile();
  fillPriceInputs();
  handleInputs();
  handleRemovingFilters();
  handleAddToBasketModals();
}

collectionScripts();
